"use strict";

exports.__esModule = true;
exports.selectable = selectable;
/**
 * Create a select-aware getter for the value of a given key.
 */
function selectable(key) {
  return function (props) {
    return props["aria-selected"] ? props.theme["Selected" + key] : props.theme[key];
  };
}